import { CheckOutlined, BarChartOutlined, CalendarOutlined, TableOutlined, FundOutlined } from '@ant-design/icons';
import type { StageConfig } from './types';

/**
 * Конфигурация вкладки "Сверка"
 * Единственный "этап" с 3 представлениями (views)
 */
export const RECONCILIATION_STAGES: StageConfig[] = [
  {
    title: 'Сверка',
    description: '-',
    icon: <CheckOutlined />,
    path: 'overview',
    rbacResource: 'reconciliation',
    views: [
      { key: 'combined', label: 'Сверка ПП и ПЗ', icon: <CheckOutlined /> },
      { key: 'period-year', label: 'По году', icon: <BarChartOutlined /> },
      { key: 'period-months', label: 'По месяцам', icon: <CalendarOutlined /> },
      { key: 'cpr-tn-sku', label: 'Дин.план от МП по ЦПР-ТН-SKU', icon: <TableOutlined /> },
      { key: 'dpz-dpp-tmz', label: 'Сверка ДПЗ и ДПП с учетом ТМЗ', icon: <FundOutlined /> },
    ],
  },
];
